<template>
  <div>
    <li class="language-select country-select">
      <h4 class="select-title" @click="openLocation = !openLocation">
        <img
          :src="'/images/country-icon/' + selectedCountry + '.png'"
          :alt="selectedCountry"
        />
      </h4>
      <ul
        class="language-dropdown"
        :class="{ open: openLocation }"
        v-if="openLocation"
      >
        <li
          v-for="option in availableCountries"
          :key="option.country_code"
          @click="setSelectedCountry(option.country_code)"
          :class="{ active: option === selectedCountry }"
        >
          <img
            :src="'/images/country-icon/' + option.country_code + '.png'"
            class="img-fluid"
          />
          <h4>{{ option.name }}</h4>
        </li>
      </ul>
    </li>
    <CountrySelectionModal
      v-if="availableCountries && availableCountries.length > 1"
    />
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import CountrySelectionModal from '@/components/Modals/CountrySelectionModal'

export default {
  name: 'NotLoggedInNav',
  components: { CountrySelectionModal },
  data() {
    return {
      openLocation: false,
      is_country_selection_popup: false,
    }
  },
  computed: {
    ...mapGetters([
      '_T',
      'selectedCountry',
      'availableCountries',
      'userLocation',
    ]),
  },
  watch: {
    availableCountries: {
      immediate: true,
      deep: true,
      handler(val) {
        if (val) {
          this.$nextTick(() => {
            let current_country =
              localStorage.getItem('selectedCountry') ||
              this.userLocation.country
            if (val) {
              this.is_country_selection_popup =
                val.find(item => item.country_code == current_country) ==
                undefined
            }
            if (this.is_country_selection_popup)
              this.$bvModal.show('country-selection-modal')
          })
        }
      },
    },
  },
  /*mounted() {
    this.accessFromOtherCountry
  },*/
  methods: {
    setSelectedCountry(country) {
      this.openLocation = !this.openLocation
      //if selected country is not the country which was auto detected then reset the city
      if (this.selectedCountry !== country) {
        this.$store.commit('SET_SELECTED_CITY', undefined)
      }
      this.$store.dispatch('setSelectedCountry', country)
    },
  },
}
</script>
<style lang="scss" scoped>
.body-rtl {
  .header-section {
    .menu-right {
      li {
        &:last-child {
          /*padding-right: unset;*/
          padding-right: 20px;
        }
      }
      .language-select {
        .language-dropdown {
          right: unset;
          left: 0;
          li {
            text-align: right;
            img,
            svg {
              margin-right: unset;
              margin-left: 0.938rem;
            }
          }
        }
      }
    }
  }
}
.header-section {
  .menu-right {
    margin-left: auto;
    display: flex;
    align-items: center;
    li {
      position: relative;
      padding-left: 1.5rem;
      padding-right: 1.5rem;
      &:first-child {
        padding-left: 0;
        &:after {
          display: none;
        }
      }
      &:last-child {
        padding-right: 0;
      }
      &:after {
        content: '';
        position: absolute;
        left: 0;
        height: 1.875rem;
        width: 0.063rem;
        background-color: $light-border;
        top: 50%;
        transform: translateY(-50%);
      }
    }
    .language-select {
      position: relative;
      .select-title {
        line-height: 1.125rem;
        color: $font-color;
        text-transform: capitalize;
        font-weight: 600;
        cursor: pointer;
        margin-bottom: 0;
        font-size: 1rem;
      }
      .language-dropdown {
        position: absolute;
        top: 0.75rem;
        right: 0;
        background-color: $white;
        width: 14.625rem;
        max-height: 15.625rem;
        overflow-x: hidden;
        overflow-y: auto;
        box-shadow: 0 $px3 15px rgba($black, 0.1);
        padding: 0.75rem 0.313rem;
        opacity: 0;
        visibility: hidden;
        transition: all 0.5s ease;
        z-index: 99;
        li {
          display: flex;
          align-items: center;
          padding: 0.5rem 0.625rem;
          border-radius: 0.125rem;
          cursor: pointer;
          transition: all 0.5s ease;
          img,
          svg {
            width: 1.125rem;
            margin-right: 0.938rem;
          }
          &:after {
            display: none;
          }
          h4 {
            margin-bottom: 0;
            text-transform: capitalize;
            font-weight: 500;
            font-size: 1rem;
          }
          &.active {
            h4 {
              color: $color-primary;
              transition: all 0.5s ease;
              font-weight: 600;
            }
          }
          &:hover {
            background: $color-primary;
            color: $white;
            transition: all 0.5s ease;
          }
        }
        &.open {
          opacity: 1;
          visibility: visible;
          top: 1.875rem;
          transition: all 0.5s ease;
        }
      }
      &.country-select {
        .select-title {
          img {
            width: 1.5rem;
            height: 1.5rem;
            border-radius: 100%;
          }
        }
      }
    }
  }
}
</style>
